const deepMerge = require('./deep-merge');
const uuidv4 = require('./uuidv4');

const printContent = function(content) {
    var iframe = document.createElement('iframe');
    iframe.classList.add('visually-hidden');
    document.body.append(iframe);
    iframe.contentWindow.document.open();
    iframe.contentWindow.document.write(response);
    iframe.contentWindow.document.close();
    iframe.contentWindow.onafterprint = function() {
        iframe.remove();
    };
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
};

const printElement = function(element, opts) {

};

const printRequest = function(url) {
    fetch(url).then(function(response) {
        response.text();
    }).then(function(text) {
        printContent(text);
    });
};

const print = function(element, opts) {
    opts = deepMerge({
        margin: 0.1,
        filename: uuidv4() + '.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    }, opts || {});
    var pdf = html2pdf().set(opts).from(element);
return pdf;
    // pdf.save();

    var w = window.open("about:blank", "", "width=800,height=600");
    if (w) {
        w.document.write(pdf.toImg());
        w.document.close();
        w.focus();
        w.print();
        w.close();
    }
};

window.printElement = print;

module.exports = print;